import { Threshold } from '@/types/AQLConfig';
import React, { useState } from 'react';

interface Props {
  initialThresholds: Threshold[];
  onSave: (thresholds: Threshold[]) => void;
}

const AQLForm: React.FC<Props> = ({ initialThresholds, onSave }) => {
  const [thresholds, setThresholds] = useState<Threshold[]>(initialThresholds);

  const updateThreshold = (index: number, field: keyof Threshold, value: number) => {
    const updated = [...thresholds];
    updated[index][field] = value;
    setThresholds(updated);
  };

  const addThreshold = () => {
    setThresholds([...thresholds, { lotSize: 0, sampleSize: 0, critical: 0, major: 0, minor: 0 }]);
  };

  const removeThreshold = (index: number) => {
    setThresholds(thresholds.filter((_, i) => i !== index));
  };

  return (
    <div>
      <table className="w-full table-auto border">
        <thead>
          <tr className="bg-gray-100">
            <th>Lot Size</th>
            <th>Sample Size</th>
            <th>Critical</th>
            <th>Major</th>
            <th>Minor</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {thresholds.map((t, index) => (
            <tr key={index}>
              {(['lotSize', 'sampleSize', 'critical', 'major', 'minor'] as const).map((field) => (
                <td key={field}>
                  <input
                    type="number"
                    className="w-full border px-2 py-1"
                    value={t[field]}
                    onChange={(e) => updateThreshold(index, field, parseInt(e.target.value))}
                  />
                </td>
              ))}
              <td>
                <button
                  className="text-red-500 hover:text-red-700"
                  onClick={() => removeThreshold(index)}>
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={addThreshold} className="mt-2 rounded bg-blue-500 px-4 py-2 text-white">
        Add Threshold
      </button>
      <button
        onClick={() => onSave(thresholds)}
        className="ml-4 mt-2 rounded bg-green-600 px-4 py-2 text-white">
        Save
      </button>
    </div>
  );
};

export default AQLForm;
